import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from '@material-ui/core';
import { Button, Input } from '@ipc/ipc-components';
import {
  uploadRfidFileRequestActionCreator,
  uploadRfidfileSetSubmitted,
} from '../redux/actions/RfidFileUploadActions';
import FileInput from '../../../../common/FileInput';
import { getSubmitting, getValidation, getSubmitted } from '../redux/selectors/RfidUploadFileSelectors';

export const FormStyle = styled.div`
  input {
    margin-bottom: 20px;
    width: 70%;
  }
  .MuiDialogActions-root {
    margin-top: 10px;
  }
`;

class RfidFileUploadDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      auto: true,
      fields: {
        filename: '',
        file: null,
        description: '',
      },
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleHide = this.handleHide.bind(this);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { submitted } = this.props;

    if (submitted) {
      this.handleHide();
    }
  }

  isFormValid = () => !(this.state.fields.filename === ''
    || this.state.fields.file === null)

  handleInputChange(e) {
    const { fields, auto } = this.state;
    const { name, value, files } = e.target;

    let newAuto = auto;
    let { filename } = fields;
    if (files && auto) {
      const slashIndex = value.lastIndexOf('\\');
      const dotIndex = value.lastIndexOf('.');
      filename = value.slice(slashIndex + 1, dotIndex); // filename without extension and pathname
    }
    if (name === 'filename') {
      newAuto = false;
    }

    this.setState({
      fields: {
        ...fields,
        filename,
        [name]: files ? files[0] : value,
      },
      auto: newAuto,
    });
  }

  handleSubmit(e) {
    e.preventDefault();

    const { uploadRfidFile } = this.props;
    const { fields: { filename, description, file } } = this.state;

    uploadRfidFile(file, JSON.stringify({ fileName: filename, description }));
  }

  handleHide() {
    const { hideModal, setSubmitted } = this.props;

    setSubmitted(false);

    this.setState({
      auto: true,
      fields: {
        filename: '',
        file: null,
        description: '',
      },
    });

    hideModal();
  }

  render() {
    const {
      open,
      hideModal,
      validation,
      submitting,
    } = this.props;
    const { fields: { filename, description, file } } = this.state;

    return (
      <Dialog open={open} onClose={hideModal} maxWidth="xs" fullWidth>
        <DialogTitle id="simple-dialog-title">
          Upload RFID File
        </DialogTitle>
        <DialogContent>
          <FormStyle>
            <form onSubmit={this.handleSubmit}>
              <Grid>
                <Input
                  placeholder="File Name"
                  name="filename"
                  onChange={this.handleInputChange}
                  value={filename}
                  required
                />
              </Grid>
              <Grid>
                <Input
                  placeholder="Description"
                  name="description"
                  onChange={this.handleInputChange}
                  value={description}
                  maxLength={45}
                />
              </Grid>
              <FileInput
                accept="csv"
                inputProps={{ name: 'file' }}
                onChange={this.handleInputChange}
                validation={validation}
                filepath={file ? file.name : null}
              />
              <DialogActions>
                <Button
                  type="button"
                  className="primary-button"
                  onClick={hideModal}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  className={`primary-button-${!this.isFormValid()}`}
                  disabled={!this.isFormValid()}
                >
                  {submitting ? 'Loading...' : 'Confirm'}
                </Button>
              </DialogActions>
            </form>
          </FormStyle>
        </DialogContent>

      </Dialog>
    );
  }
}

RfidFileUploadDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  submitted: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  validation: PropTypes.shape({
    file: PropTypes.string,
  }),
  hideModal: PropTypes.func.isRequired,
  setSubmitted: PropTypes.func.isRequired,
  uploadRfidFile: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    validation: getValidation(state),
    submitting: getSubmitting(state),
    submitted: getSubmitted(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  uploadRfidFile: uploadRfidFileRequestActionCreator,
  setSubmitted: uploadRfidfileSetSubmitted,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RfidFileUploadDialog);
